//#region import
import React, { useEffect, useState } from 'react'
import { Grid, Divider, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnDeleteOnTable, BtnEditOnTable } from 'components/Button/ButtonTable';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { BtnAdd, BtnBack, BtnDuplicate, BtnSave } from 'components/Button/ButtonAll';
import { FormProvider, useForm } from 'react-hook-form'
import { SelectItem } from 'components/Input/Select/SelectItem';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { AutoCompleteItem } from 'components/Input/AutoComplete';
import SwitchFormItem from 'components/Input/Switch';
import moment from 'moment';
//#endregion

const CommitteeForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const onBack = () => navigate("/CommitteeList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [arrRound, setarrRound] = useState<any>([]);
    const [arrCommittee, setarrCommitteeType] = useState([]);
    const [arrPosition, setarrPosition] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dMinYear, setMinYear] = useState() as any;
    const [dMaxYear, setMaxYear] = useState() as any;

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [dataRow2, setDataRow2] = useState<PaginationInterface>({
        ...initRows,
    });

    const [dataRow3, setDataRow3] = useState<PaginationInterface>({
        ...initRows,
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    const form44 = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const form45 = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const form46 = useForm({
        shouldFocusError: true,
        mode: "all"
    });

    // Permission
    const [isPermission, setPermission] = useState<boolean>(false);
    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleAddItem = () => {
        //set max and min date of year
        let dYear = moment(form.getValues("dYear"));
        let dMin = new Date(dYear.year(), 0, 1);
        setMinYear(dMin);
        let dMax = new Date(dYear.year(), 11, 31);
        setMaxYear(dMax);

        if (sID == null) {
            form.setValue("dStart", dMin);
            form.setValue("dEnd", dMax);

        }

    }

    const getFormInitial = () => {
        AxiosFn.Get(`Committee/GetFormInitial`, {}, (result) => {
            setarrCommitteeType(result.lstCommitteeType || []);
            setarrPosition(result.lstCommitteePositions || []);
            if (!sID) {
                setarrRound(result.lstRound || []);
                form.setValue(`nRound`, result.nRound);
                form.setValue(`dYear`, result.sYear);
                handleAddItem();
            }
        })
    }

    const getRound = (e) => {

        let nYear = moment(form.getValues("dYear")).valueOf();
        let param = {
            nYearID: nYear
        }
        AxiosFn.Post(`Committee/GetRound`, param, (result) => {
            setarrRound(result.lstRound || []);
            form.setValue(`nRound`, result.nRound);
        })
    }

    const onSubmit = (e, nMode) => {
        let lstDataType = []
        let lstData = []
        lstData = dataRow.arrRows;
        lstData.forEach((item) => {
            lstDataType.push({
                label: item.label,
                nUserID: item.value,
                nPosition: item.nPosition,
                nOrder: item.nOrder,
                IsDelete: item.IsDelete ? item.IsDelete : false,
                nCommitteeTypeID: item.nCommitteeTypeID,
                nCommitteeID: item.nCommitteeID,
                nCommitteeRoundID: item.nCommitteeRoundID,
            })
        })

        lstData = dataRow2.arrRows;
        lstData.forEach((item) => {
            lstDataType.push({
                label: item.label,
                nUserID: item.value,
                nPosition: item.nPosition,
                nOrder: item.nOrder,
                IsDelete: item.IsDelete ? item.IsDelete : false,
                nCommitteeTypeID: item.nCommitteeTypeID,
                nCommitteeID: item.nCommitteeID,
                nCommitteeRoundID: item.nCommitteeRoundID,
            })
        })

        lstData = dataRow3.arrRows;
        lstData.forEach((item) => {
            lstDataType.push({
                label: item.label,
                nUserID: item.value,
                nPosition: item.nPosition,
                nOrder: item.nOrder,
                IsDelete: item.IsDelete ? item.IsDelete : false,
                nCommitteeTypeID: item.nCommitteeTypeID,
                nCommitteeID: item.nCommitteeID,
                nCommitteeRoundID: item.nCommitteeRoundID,
            })
        })

        let param = {
            sID: sID ? sID : "",
            nYearID: moment(form.getValues("dYear")).valueOf(),
            nRound: form.getValues("nRound"),
            nEffective: form.getValues("dEffective").valueOf(),
            isActive: form.getValues("isActive"),
            lstDataUser: lstDataType,
            nMode: nMode
        };
        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`Committee/SaveCommittee`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate(`/CommitteeList`);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const GetCommitteeEdit = () => {
        let param = {
            sID: sID ? sID : ""
        };
        setLoading(true);
        AxiosFn.Post(`Committee/GetCommitteeEdit`, param, (result) => {
            if (sID) {
                form.setValue(`nRound`, result.nRound);
                form.setValue("dYear", result.sYear);
                form.setValue("dEffective", moment(result.nEffective));
                form.setValue("isActive", result.isActive);
                handleAddItem();
                setarrRound(result.lstRound || []);
                setDataRow({
                    ...dataRow,
                    arrRows: result.lstSubcommittee
                });

                setDataRow2({
                    ...dataRow2,
                    arrRows: result.lstExecutiveCommittee
                });

                setDataRow3({
                    ...dataRow3,
                    arrRows: result.lstTrackingBoard
                });
                setLoading(false);
            }
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    useEffect(() => {
        getFormInitial();
        GetCommitteeEdit();
    }, []);

    //Table คณะกรรมการ
    const handleSubmit = (e, nCommitteeTypeID, formNew) => {
        let lstDataType = []
        lstDataType.push({
            label: e[`nUserID_${nCommitteeTypeID}`] ? e[`nUserID_${nCommitteeTypeID}`].label : "",
            value: e[`nUserID_${nCommitteeTypeID}`] ? e[`nUserID_${nCommitteeTypeID}`].value : 0,
            nPosition: e[`nPosition_${nCommitteeTypeID}`] ? e[`nPosition_${nCommitteeTypeID}`] : 0,
            nCommitteeTypeID: nCommitteeTypeID,
        })

        let param = {
            lstUser: lstDataType[0],
            sLocation: location.pathname,
            lstDataRow: nCommitteeTypeID == EnumCommitteeType.nSubcommittee ? dataRow.arrRows : nCommitteeTypeID == EnumCommitteeType.nExecutiveCommittee ? dataRow2.arrRows : dataRow3.arrRows
        }
        AxiosFn.Post(`Committee/GetUser`, param, (result) => {
            setLoading(false);
            if (nCommitteeTypeID === EnumCommitteeType.nSubcommittee) {
                setDataRow({
                    ...dataRow,
                    arrRows: result.lstUser
                });
            } else if (nCommitteeTypeID === EnumCommitteeType.nExecutiveCommittee) {
                setDataRow2({
                    ...dataRow2,
                    arrRows: result.lstUser
                });
            } else if (nCommitteeTypeID === EnumCommitteeType.nTrackingBoard) {
                setDataRow3({
                    ...dataRow3,
                    arrRows: result.lstUser
                });
            }
            formNew.setValue(`nUserID_${nCommitteeTypeID}`, null);
            formNew.setValue(`nPosition_${nCommitteeTypeID}`, null);

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        )
    };

    const OnDelete = (sID, nCommitteeTypeID) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let arrClone = nCommitteeTypeID == EnumCommitteeType.nSubcommittee ? dataRow : nCommitteeTypeID == EnumCommitteeType.nExecutiveCommittee ? dataRow2 : dataRow3;
            arrClone.arrRows = arrClone.arrRows.filter((f) => !sID.includes(f.sID));

            //เรียง Order ใหม่
            if (arrClone.arrRows.length > 0) {
                let nOrder = 1;
                arrClone.arrRows.forEach((f) => {
                    f.nOrder = nOrder;
                    f.sID = nOrder + "";
                    nOrder++;
                });
            }
            if (nCommitteeTypeID == EnumCommitteeType.nSubcommittee) {
                setDataRow({ ...arrClone });
            } else if (nCommitteeTypeID == EnumCommitteeType.nExecutiveCommittee) {
                setDataRow2({ ...arrClone });
            } else if (nCommitteeTypeID == EnumCommitteeType.nTrackingBoard) {
                setDataRow3({ ...arrClone });
            }

            DialogFn.Success();
        });

    };

    const onEdit = (ObjData, nCommitteeTypeID, sID) => {
        let ObjProblem = {
            nPosition: ObjData.nPosition,
            nCommitteeTypeID: ObjData.nCommitteeTypeID,
            nUserID: ObjData.value,
            nUserName: ObjData.label,
        };

        let arrClone = nCommitteeTypeID == EnumCommitteeType.nSubcommittee ? dataRow : nCommitteeTypeID == EnumCommitteeType.nExecutiveCommittee ? dataRow2 : dataRow3;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.isEdit = f.sID == sID ? true : false;
            });
        }

        if (nCommitteeTypeID == EnumCommitteeType.nSubcommittee) {
            setDataRow({ ...arrClone });
        } else if (nCommitteeTypeID == EnumCommitteeType.nExecutiveCommittee) {
            setDataRow2({ ...arrClone });
        } else if (nCommitteeTypeID == EnumCommitteeType.nTrackingBoard) {
            setDataRow3({ ...arrClone });
        }
        let fomrNew = nCommitteeTypeID == 44 ? form44 : nCommitteeTypeID == 45 ? form45 : form46;
        fomrNew.setValue(`nUserID_${nCommitteeTypeID}`, { value: ObjProblem.nUserID, label: ObjProblem.nUserName });
        fomrNew.setValue(`nPosition_${nCommitteeTypeID}`, ObjProblem.nPosition);
    }

    const dataColumn: any = [
        {
            field: "ลบ",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 150,
            disableColumnMenu: true,
            getActions: (item) => {
                return [
                    <Grid container spacing={2} key={item.row.sID}>
                        <Grid item xs={12} md={6} >
                            <BtnDeleteOnTable
                                id="btnDelete"
                                key={item.row.sID}
                                onClick={() => OnDelete(item.row.sID, item.row.nCommitteeTypeID)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <BtnEditOnTable
                                key={item.row.sID}
                                id="btnEdit"
                                onClick={() => onEdit(item.row, item.row.nCommitteeTypeID, item.row.sID)}
                            />
                        </Grid>
                    </Grid>
                ];

            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            align: "center",
            resizable: false,
            sortable: false,
            width: 60,
            disableColumnMenu: true,
        },
        {
            field: "sUserName",
            headerName: "ชื่อ - สกุล",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,

        },
        {
            field: "sPosition",
            headerName: "ตำแหน่ง",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
        },

    ];


    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                        <DatePickerItem
                            name={`dYear`}
                            id={`dYear`}
                            label={"ปี"}
                            IsYearPicker
                            required={true}
                            disabled={sID != null || !isPermission}
                            onChange={(e) => {
                                getRound(e ? e : null)
                                handleAddItem()
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SelectItem
                            id="nRound"
                            name={"nRound"}
                            label={"รอบ"}
                            placeholder={"รอบ"}
                            options={arrRound}
                            required={true}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            name={"dEffective"}
                            id={"dEffective"}
                            label={"วันที่มีผลบังคับใช้"}
                            fullWidth
                            disabled={!isPermission}
                            required={true}
                            minDate={dMinYear}
                            maxDate={dMaxYear}
                            defaultCalendarMonth={moment().startOf('year').year(moment(form.getValues("dYear")).year())}
                        />
                    </Grid>

                    {arrCommittee.map((m, index) => {
                        let formNew = m.value == 44 ? form44 : m.value == 45 ? form45 : form46;
                        return (
                            <Grid item xs={12} md={12} key={index} >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12} style={{ marginTop: "2%" }}  >
                                        <Typography fontSize={18} fontWeight={500}>
                                            {m.label} {m.value != 46 ? <span style={{ color: "red" }}> * </span> : ""}
                                        </Typography>
                                        <Divider />
                                    </Grid>
                                    <FormProvider  {...formNew} >
                                        <Grid container spacing={2} style={{ marginTop: "1%", padding: "10px", margin: "10px" }}>
                                            <Grid item xs={12} md={5}>
                                                <AutoCompleteItem
                                                    id={`nUserID_${m.value}`}
                                                    name={`nUserID_${m.value}`}
                                                    sUrlAPI={`Committee/GetSearchUser`}
                                                    label={`ชื่อ - นามสกุล`}
                                                    placeholder={`ชื่อ - นามสกุล`}
                                                    required={true}
                                                    disabled={!isPermission}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <SelectItem
                                                    id={`nPosition_${m.value}`}
                                                    name={`nPosition_${m.value}`}
                                                    label={"ตำแหน่ง"}
                                                    placeholder={"ตำแหน่ง"}
                                                    options={arrPosition.filter(f => f.nParentID === m.value)}
                                                    required={true}
                                                    disabled={!isPermission}
                                                />
                                            </Grid>
                                            <Grid item container justifyContent="flex-end" xs={12} md={12}>
                                                <BtnAdd id={"btnSave"}
                                                    txt={m.value == EnumCommitteeType.nSubcommittee ? "เพิ่มอนุกรรมการกลั่นกรอง" : m.value == EnumCommitteeType.nExecutiveCommittee ? "เพิ่มกรรมการบริหาร" : " เพิ่มกรรมการติดตาม"}
                                                    onClick={formNew.handleSubmit((e) => { handleSubmit(e, m.value, formNew) })}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sx={{ mt: 1 }}>
                                                <DataGrid
                                                    columns={dataColumn}
                                                    rows={m.value == EnumCommitteeType.nSubcommittee ? dataRow : m.value == EnumCommitteeType.nExecutiveCommittee ? dataRow2 : dataRow3}
                                                    isHiddenToolHead={true}
                                                    isHiddenFooter={true}
                                                    isShowCheckBox={false}
                                                    isDisableColumnMenu={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    </FormProvider>
                                </ Grid>
                            </ Grid>
                        )
                    })}

                    <Grid item xs={12} md={12}>
                        <Typography>
                            สถานะ
                            <span style={{ color: "red" }}> * </span>
                        </Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <SwitchFormItem
                            name={"isActive"}
                            checkText='ใช้งาน'
                            uncheckText='ไม่ใช้งาน'
                            width={130}
                            id={"isActive"}
                            disabled={!isPermission}
                        />
                    </Grid>
                </Grid>

                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={7}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>
                    <Grid container item md={2} xs={3} justifyContent="flex-end" >
                        <BtnDuplicate id={"btnDuplicate"} onClick={form.handleSubmit((e) => { onSubmit(e, 2) })} />
                    </Grid>
                    <Grid container item md={2} xs={3} justifyContent="flex-end">
                        <BtnDuplicate bgcolor='#ffad00' bgcolorHover='#e69c00' txt='คัดลอกไปยังรอบถัดไป' id={"btnDuplicate"} onClick={form.handleSubmit((e) => { onSubmit(e, 3) })} />
                    </Grid>
                    <Grid container item xs={6} md={1} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e, 1),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>
            </FormProvider>
        </React.Fragment >
    )
}
export default CommitteeForm;

export const enum EnumCommitteeType {
    nSubcommittee = 44,
    nExecutiveCommittee = 45,
    nTrackingBoard = 46,
}